import { createSwitchingStatusComposable } from '@/composables/create-switching-status-composable';

/**
 * Provides Prepare Swaps parent job progress for display, via one of two mechanisms
 * selected by the `switching.usePollingForUpdates` feature flag:
 *  - Polling (flag on): actively fetches `/prepare-swaps/status` on an interval.
 *  - Push (flag off, default): reads data already kept fresh in the scenarios store by
 *    the Dapr-driven statusUpdate SSE push (see stores/events.js).
 *
 * Auto-resumes polling on mount if a job is already in progress (polling mode only).
 * In push mode, fires a one-off reconciliation request on mount instead, so a job left
 * stuck by a missed/dropped Dapr event is corrected on page load. Stops on unmount.
 *
 * The endpoint also reconciles the active child switching stage before returning the
 * parent status, so missed UI polling or missed push events self-heal on reload.
 */
export const usePrepareSwapsStatus = createSwitchingStatusComposable({
  statusUrl: id => `/api/scenarios/${id}/prepare-swaps/status`,
  getJobStatus: jobStatuses => jobStatuses?.prepareSwaps,
  detailsKey: 'serviceJobDetails',
});
